var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSortTeal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_699_2975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5L6 4.5L3 7.5",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_699_2975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5L6 13.5L9 10.5",
    stroke: "#00B8B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_699_2975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(-1 0 0 -1 12 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_699_2975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortTeal);
export default __webpack_public_path__ + "static/media/Icon_Sort_Teal.01590a61ad975ce08df27c3516051ab7.svg";
export { ForwardRef as ReactComponent };